import { useEffect } from "react";
import { useCloud } from "./useCloud";
import store from "../store/index"; // Adjust the path as necessary
import useOrder from "./useOrder";
import useNotifications from "./useNotifications";
import { transformDigitalOrderItems } from "../utils/common";
import { SUCCESS } from "../assets/constants";
import { withSpan, addBreadcrumb, captureException, setSpanAttribute } from "../utils/sentry";
import { updateUserContext } from "../utils/sentryInit";
export const useStore = () => {
  const { registerToken } = useNotifications();
  const {
    // V2
    getRestaurantInfo,
    getMenu,
  } = useCloud();

  const getCloudSync = async () => {
    return withSpan(
      {
        name: "Cloud Sync - Get Restaurant Info",
        op: "app.sync",
        function: "getCloudSync",
      },
      async (span) => {
        try {
          if (window.location.pathname === "/login") {
            store.appBooting = false;
            span?.setStatus("ok");
            return;
          }
          
          addBreadcrumb("Starting cloud sync", "app.sync");
          registerToken();
          const restaurantInfo = await getRestaurantInfo();
          if (restaurantInfo && restaurantInfo.status === SUCCESS) {
        const {
          staff,
          rooms,
          gstRate,
          gstItemType,
          gstNumber,
          isGst,
          fassi_no,
          vat,
          serviceTaxEnabled,
          serviceTaxRate,
          ...info
        } = restaurantInfo.data;

        store.rooms = rooms;
        store.tables = rooms.reduce((acc, room) => {
          const tables = room.tables.map((table) => ({
            ...table,
            room: room.roomName,
          }));
          acc.push(...tables);
          return acc;
        }, []);

        store.staff = staff;

        store.GST = {
          rates: gstRate,
          gstType: gstItemType,
          gstNumber: gstNumber,
          active: isGst,
          fassi_no: fassi_no,
          vat,
          serviceTaxRate: serviceTaxRate,
          serviceTaxEnabled: serviceTaxEnabled,
        };
            store.restaurantInfo = {
              ...info,
            };
            store.isLoggedIn = true;
            
            // Update Sentry user context
            updateUserContext();
            
            setSpanAttribute(span, "sync.success", true);
            span?.setStatus("ok");
          }
          store.appBooting = false;
        } catch (err) {
          console.error("Failed to fetch data:", err);
          setSpanAttribute(span, "sync.success", false);
          span?.setStatus("internal_error");
          captureException(err, {
            tags: { component: "useStore", action: "getCloudSync" },
          });
        }
      }
    );
  };

  useEffect(() => {
    const fetchOnline = async () => {
      await getCloudSync();
    };
    fetchOnline();
  }, []);

  return { store, getCloudSync };
};

export default useStore;
